import { render, staticRenderFns } from "./pushRiskCase.vue?vue&type=template&id=3cac0ad9"
import script from "./pushRiskCase.vue?vue&type=script&lang=js"
export * from "./pushRiskCase.vue?vue&type=script&lang=js"
import style0 from "./pushRiskCase.vue?vue&type=style&index=0&id=3cac0ad9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports